import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import { roles } from '../../constants/roles';
import getSalesAgentById from '../SalesAgents/getSalesAgentById.api';

const firebaseRef = firebase.database();

export default async function getUserById(userId) {
	console.log('getUserById  userId', '/users/' + userId);
	var userObj;
	await firebaseRef.ref('/users/' + userId).once('value', (snapshot) => {
		userObj = snapshot.val();
	});

	return userObj;
}
